<template>
    <!-- Componente para mostrar el formulario de cotización de cetelem -->
    <section id="cetelem-form" class="quotation px-4 max-w-screen-lg xl:max-w-screen-xl mx-auto mb-20">
        <button
            v-show="!showLoader"
            class="flex items-center space-x-1 sm:space-x-2 hover:opacity-75"
            @click="$emit('back-to-simulator')"
        >
            <span class="text-light-blue">
                <i class="fa-solid fa-chevron-left fa-lg"></i>
            </span>
            <span class="inline-block text-sm sm:text-base">Regresar al simulador de crédito</span>
        </button>
        <div v-show="showIframe">
            <iframe
                v-if="appEnv === 'production'"
                class="iframe-cetelem"
                :src="`https://hyundaimotormex-leads.com/${isIframe ? 'f1' : 'f2'}/cotizacion_cetelem/?dealer_code=${subsidiary}&modelo=${modelName}&version=${versionName}&year=${modelYear}&enganche=${enganche}&plazo=${term}&mensualidad=${pagoMensual}`"
                width="100%"
                scrolling="no"
                style="border: 0"
            ></iframe>
            <!-- <div v-else-if="appEnv === 'local'" class="mt-10">
                <button class="hyundai-button mx-auto" @click="sendCetelemData()">Enviar datos</button>
            </div> -->
            <iframe
                v-else
                class="iframe-cetelem"
                :src="`https://test.hyundaimotormex-leads.com/${isIframe ? 'f1' : 'f2'}/cotizacion_cetelem/?dealer_code=${subsidiary}&modelo=${modelName}&version=${versionName}&year=${modelYear}&enganche=${enganche}&plazo=${term}&mensualidad=${pagoMensual}`"
                width="100%"
                scrolling="no"
                style="border: 0"
            ></iframe>
        </div>
        <div v-show="showLoader" class="text-center">
            <div class="lds-dual-ring mx-auto mt-40"></div>
            <p class="text-light-blue">Cargando...</p>
        </div>
        <div v-show="showSuccessMessage" class="mt-20">
            <p class="md:w-6/12 mx-auto">
                Muchas gracias por compartirnos tus datos, a la brevedad llegará a tu correo electrónico la Tabla de
                Amortización. También podrás descargarla haciendo clic en el siguiente botón:
            </p>
            <a :href="urlPDF" class="hyundai-button mx-auto mt-10" download>Descargar Tabla de Amortización</a>
            <figure class="w-64 mt-5 mx-auto cursor-pointer" v-if="showCreditBtn" @click="showCreditSwal">
                <img class="w-full" :src="url + '/images/cetelem_button.png'" alt="Comienza tu solicitud en línea" />
            </figure>
            <!-- <button
                v-if="showCreditBtn"
                class="hyundai-button mx-auto mt-4"
                @click="showCreditSwal"
                >
                Comienza tu solicitud en línea
            </button> -->
        </div>
    </section>
</template>

<script>
import Swal from "sweetalert2";
export default {
    props: [
        "showCetelemForm",
        "subsidiary",
        "subName",
        "modelName",
        "versionName",
        "modelYear",
        "term",
        "pagoMensual",
        "montoTotal",
        "totalPagar",
        "idAseguradora",
        "idPlan",
        "enganche",
        "cetelemData",
        "appEnv",
        "isIframe",
    ],
    data() {
        return {
            // Variable para almacenar la url base del sitio
            url: $(".url").text(),
            // Variable para almacenar el slug del dealer correspondiente
            webpage: $(".webpage").text(),
            // Variable para determinar si mostrar el iframe o no
            showIframe: true,
            // Variable para determinar si el ambiente está en producción
            envProd: this.appEnv === "production" ? true : false,
            // Variable para determinar si mostrar el mensaje
            // de éxito al usuario o no
            showSuccessMessage: false,
            // Variable para determinar si mostrar y ocultar
            // el loader
            showLoader: false,
            // Variable para almacenar la url del PDF generado
            // de la tabla de amortización
            urlPDF: "",
            // Variable para almacenar el folio de la cotización generada
            folio: "",
            // Variable para almacenar el mensaje recibido del iframe
            iframeMessage: {},
            // Variable para determinar si mostrar o no el botón
            // de solicitud de crédito en línea con Cetelem
            showCreditBtn: false,
        };
    },
    // watch: {
    //     showLoader: function (val) {
    //         if (val) {
    //             $("html, body").animate(
    //                 {
    //                     scrollTop: 0,
    //                 },
    //                 1000
    //             );
    //         }
    //     },
    // },
    methods: {
        // Función para guardar el PDF de la tabla de amortización
        storePdf() {
            console.log("/cetelem/store-pdf");
            // Axios para guardar el PDF de la tabla de amortización en BD
            // y asignar la url resultante para la descarga del mismo
            axios
                .post(`${this.url}/cetelem/store-pdf`, {
                    pdf_url: this.urlPDF,
                    nombre: this.iframeMessage.id,
                })
                .then((resp) => {
                    if (resp.data.success) {
                        this.urlPDF = this.url + "/storage/cetelem/" + resp.data.pdf_name;
                        this.showLoader = false;
                        this.showSuccessMessage = true;
                    } else {
                        this.swalError();
                    }
                })
                .catch((err) => {
                    console.log("/cetelem/store-pdf FAIL", err);
                    this.swalError();
                });
        },
        // Función para mostar alertas de error
        swalError() {
            Swal.fire({
                icon: "error",
                title: '<h3 class="text-2xl leading-tight font-medium">Hubo un problema al procesar tu solicitud</h3>',
                html: "<p>Intentalo de nuevo más tarde</p>",
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "text-center bg-dark-blue text-white w-64 lg:w-40 text-sm py-2",
                },
                buttonsStyling: false,
                didClose: () => {
                    this.$emit("back-to-simulator");
                },
            });
        },
        // Función para mostrar alerta para salir del sitio
        // y continuar la solicitud de crédito desde Cetelem
        showCreditSwal() {
            Swal.fire({
                icon: "info",
                title: '<h3 class="text-2xl leading-tight font-medium">Solicitud Digital</h3>',
                html: "<p>Estás a punto de abandonar el sitio web de Hyundai para ingresar al sitio web de Cetelem y continuar con el trámite de tu Solicitud Digital.</p>",
                confirmButtonText: "Aceptar",
                showCancelButton: true,
                cancelButtonText: "Cancelar",
                customClass: {
                    confirmButton: "text-center bg-dark-blue text-white w-64 lg:w-40 text-sm py-2",
                    cancelButton: "text-center bg-dark-blue text-white w-64 lg:w-40 text-sm py-2 lg:ml-4 mt-3 lg:mt-0",
                },
                buttonsStyling: false,
            }).then((result) => {
                // Si el usuario acepta continuar su solicitud con Cetelem
                // se asignan las variables necesarias para los query params
                // de la url de cetelem y se carga la url resultante
                if (result.isConfirmed) {
                    let idsync = {
                        idEvento: this.iframeMessage.id,
                        franjaOrigen: this.isIframe ? "f1" : "f2",
                        urlOrigen: this.isIframe ? "https://www.hyundai.com.mx" : window.location.href,
                        urlDestino: this.isIframe ? "https://www.hyundai.com.mx" : `${this.url}/${this.webpage}`,
                    };
                    console.log(idsync);
                    // Si el flujo está en producción carga las urls de
                    // producción de cetelem, en caso contrario las de pruebas
                    if (this.envProd) {
                        // Si el flujo está en el iframe abre una nueva ventana
                        // en el parent, en caso contrario carga la url en la misma ventana
                        if (this.isIframe) {
                            window
                                .open(
                                    `https://cck.creditoclick.com.mx/cotizador-api-web/hyundai/solicitud?folio=${
                                        this.folio
                                    }&idsync=${btoa(JSON.stringify(idsync))}`,
                                    "_parent",
                                )
                                .focus();
                        } else {
                            window.location.href = `https://cck.creditoclick.com.mx/cotizador-api-web/hyundai/solicitud?folio=${
                                this.folio
                            }&idsync=${btoa(JSON.stringify(idsync))}`;
                        }
                    } else {
                        // Si el flujo está en el iframe abre una nueva ventana
                        // en el parent, en caso contrario carga la url en la misma ventana
                        if (this.isIframe) {
                            window
                                .open(
                                    `https://test.creditoclick.com.mx/cotizador-api-web/hyundai/solicitud?folio=${
                                        this.folio
                                    }&idsync=${btoa(JSON.stringify(idsync))}`,
                                    "_parent",
                                )
                                .focus();
                        } else {
                            window.location.href = `https://test.creditoclick.com.mx/cotizador-api-web/hyundai/solicitud?folio=${
                                this.folio
                            }&idsync=${btoa(JSON.stringify(idsync))}`;
                        }
                    }
                }
            });
        },
        // Función para enviar los datos necesarios para
        // generar una cotización en cetelem
        sendCetelemData() {
            // Esconde el iframe y muestra el loader
            this.showIframe = false;
            this.showLoader = true;
            // Asigna al iframe message los datos necesarios
            // para enviarlos al back y generar la cotización
            this.iframeMessage.data.term = this.term;
            this.iframeMessage.data.idAseguradora = this.idAseguradora;
            this.iframeMessage.data.idPlan = this.idPlan;
            this.iframeMessage.cetelemData = this.cetelemData;
            // Axios para generar la cotización de cetelem
            axios
                .post(`${this.url}/cetelem/online-lead`, {
                    iframeMessage: this.iframeMessage,
                })
                .then((resp) => {
                    console.log("/cetelem/online-lead resp", resp);
                    // Si la respuesta es éxitosa asigna las variables del
                    // datalayer la url del pdf generado para poder descargarlo
                    // y el folio de la cotización, y muestra el botón para continuar
                    // con la solicitud en línea con cetelem
                    if (resp.data.success) {
                        // dataLayer.push({
                        //     event: "cotizacion_cetelem",
                        //     id_cotizacion:
                        //         resp.data.data.quotationResponse.folio,
                        //     plazo: this.term + " meses",
                        //     pago_mensual: parseFloat(this.pagoMensual), // número
                        //     financiamiento: parseFloat(this.montoTotal), // número
                        //     total_pagar: parseFloat(this.totalPagar), // número
                        //     modelo: this.modelName,
                        //     version: this.versionName,
                        //     year_model: this.modelYear,
                        //     interes_compra:
                        //         this.iframeMessage.data.intencion_de_compra,
                        //     distribuidor: this.subName,
                        // });

                        this.urlPDF = resp.data.data.quotationResponse.urlPDF;
                        this.folio = resp.data.data.quotationResponse.folio;
                        this.showCreditBtn = parseInt(resp.data.data.quotationResponse.applyCreditOnlineButton);

                        // Axios para enlazar la cotización generada
                        axios
                            .post(`${this.url}/cotizadores/enlazar-cotizacion`, {
                                aplics_form_id: this.iframeMessage.id,
                                from_cetelem: 1,
                                // casualtyInsurance: this.seguro === 'insu' ? true : false,
                                // downPayment: this.enganche,
                                // number: this.term,
                                // year: this.year,
                                // marketValue: this.versionPrice,
                                // vehicle_id: this.versionId,
                                // bbva_api_call_id: this.bbvaQuotation.bbva_quotation_id
                            })
                            .then((resp) => {
                                console.log("/cotizadores/enlazar-cotizacion form-resp", resp);
                                // Si tiene éxito guarda el pdf de la cotización
                                // en caso contrario muestra un mensaje de error
                                if (resp.data.success) {
                                    this.storePdf();
                                } else {
                                    this.swalError();
                                }
                            })
                            .catch((error) => {
                                if (error.response) {
                                    // Request made and server responded
                                    console.log("error.response", error.response.data);
                                } else if (error.request) {
                                    // The request was made but no response was received
                                    console.log("error.request", error.request);
                                } else {
                                    // Something happened in setting up the request that triggered an Error
                                    console.log("error.message", error.message);
                                }
                                this.swalError();
                            });

                        // Almacenar PDF CETELEM
                        // this.storePdf()
                    } else {
                        this.swalError();
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        // Request made and server responded
                        console.log(error.response.data);
                    } else if (error.request) {
                        // The request was made but no response was received
                        console.log(error.request);
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        console.log("Error", error.message);
                    }
                    this.swalError();
                });
        },
    },
    mounted() {
        // Función para activar el iFrameResize
        // para mostrar correctamente el iframe del formulario
        iFrameResize({
            log: false, // Enable console logging
            enablePublicMethods: true, // Enable methods within iframe hosted page
        });

        // Función para escuchar los eventos del iframe
        function bindEvent(element, eventName, eventHandler) {
            if (element.addEventListener) {
                element.addEventListener(eventName, eventHandler, false);
            } else if (element.attachEvent) {
                element.attachEvent("on" + eventName, eventHandler);
            }
        }

        // Función para escuchar los mensajes emitidos por
        // el iframe en el sitio independiente
        bindEvent(window, "message", (e) => {
            if (e.data.id != undefined && this.showCetelemForm) {
                console.log("iframe message cetelem", e.data);
                this.$nextTick(function () {
                    let reqTop = document.getElementById("cetelem-form").getBoundingClientRect().top;
                    $("html, body").animate(
                        {
                            scrollTop: reqTop + $(window).scrollTop() - 20,
                        },
                        1000,
                    );
                });
                this.iframeMessage = e.data;
                this.sendCetelemData();
                console.log("Datos de formulario enviados");
            }
            // else {
            //     Swal.fire({
            //         icon: 'error',
            //         title: '<h3 class="text-2xl leading-tight font-medium">Hubo un problema al procesar tu solicitud</h3>',
            //         html: '<p>Intentalo de nuevo más tarde</p>',
            //         confirmButtonText: 'Aceptar',
            //         customClass: {
            //             confirmButton: 'text-center bg-dark-blue text-white w-64 lg:w-40 text-sm py-2',
            //         },
            //         buttonsStyling: false
            //     })
            // }
        });
    },
};
</script>

<style></style>
